import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Stack, Box, OutlinedInput, Button, Typography} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useDarkMode} from "../../darkMode/hook/useDarkMode";

const Contact = ({handleNextStep, handleBackStep}) => {
  const {
    control,
    formState: {errors},
    reset,
  } = useFormContext();

  const {mode} = useDarkMode();

  return (
  <Stack className={"form_group"} style={{backgroundColor : mode.settings.cardBackgroundColor}}>
      <Stack direction={"column"} alignItems={"center"}>
          <Stack width={'100%'} justifyContent={"center"} alignItems={"center"}>
              <Typography
                  className={"form_label"}
                  variant={"subtitle1"}
                  component={'label'}
                  id={'label-email'}
                  htmlFor={'email'}
                  color={mode.settings.textColor3}
              >
                  Adresse email
              </Typography>
              <Controller
                  control={control}
                  name="email"
                  rules={{
                      required: true,
                      pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                  }}
                  render={({field: {onChange, value}}) => (
                      <OutlinedInput
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={!!errors.email}
                          placeholder="jean@email.com"
                          style={{
                              maxWidth: 500,
                              width : '80%',
                              color : mode.settings.textColor3,
                              backgroundColor : mode.settings.inputBackgroundColor
                          }}
                          id="email"
                          aria-describedby="label-email"
                      />
                  )}
              />
          </Stack>
      </Stack>
      <br/>
      <Stack direction={"row"} justifyContent={"center"} spacing={2}>
          <Button
              className="btn-gradient"
              startIcon={<ArrowBackIcon role="img" aria-label={"Revenir"}/>}
              style={{
                  width : 130
              }}
              onClick={() => handleBackStep && handleBackStep()}
          >
              Revenir
          </Button>
          <Button
              className="btn-gradient"
              startIcon={<CheckIcon role="img" aria-label={"Valider"}/>}
              style={{
                  width : 130
              }}
              onClick={() => handleNextStep && handleNextStep()}
          >
              Valider
          </Button>
      </Stack>
    </Stack>
  );
};

export default Contact;
